module.exports = __webpack_public_path__ + "static/media/IMG_3280.602f47ac.JPG";